<template>
  <div>
    <el-collapse :value="['1']">
      <el-collapse-item title="分类设置" name="1">
        <cx-check-box class="mb8" :value.sync="showAll">显示"全部"分类</cx-check-box>
        <cx-check-box :value.sync="showCategoryNames">分类名称修改</cx-check-box>
        <div class="category-names mt8" v-if="showCategoryNames">
          <div class="mt16">
            <span class="font14 mr10 half-label">一级分类</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              :value="categoryNames[0]"
              @input="setNames($event, 0)"
            >
            </el-input>
          </div>
          <div class="mt16">
            <span class="font14 mr10 half-label">二级分类</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              :value="categoryNames[1]"
              @input="setNames($event, 1)"
            >
            </el-input>
          </div>
          <div class="mt16">
            <span class="font14 mr10 half-label">三级分类</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              :value="categoryNames[2]"
              @input="setNames($event, 2)"
            >
            </el-input>
          </div>
          <div class="mt16">
            <span class="font14 mr10 half-label">四级分类</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              :value="categoryNames[3]"
              @input="setNames($event, 3)"
            >
            </el-input>
          </div>
          <div class="mt16">
            <span class="font14 mr10 half-label">五级分类</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              :value="categoryNames[4]"
              @input="setNames($event, 4)"
            >
            </el-input>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  export default {
    props: {
      options: {
        type: Object
      }
    },
    computed: {
      showAll: {
        get() {
          return this.options.showAll || false
        },
        set(newVal) {
          this.$changeOptionsEV(newVal, "showAll", false)
        } 
      },
      showCategoryNames: {
        get() {
          return this.options.showCategoryNames
        },
        set(newVal) {
          this.$changeOptionsEV(newVal, "showCategoryNames", false)
        } 
      },
      categoryNames() {
        return this.options.categoryNames || []
      },
      pageType() {
        return this.$store.state[this.request_prefix].type
      },
    },
    methods: {
      setNames(value, index) {
        this.options.categoryNames.splice(index, 1, value)
      }
    }
  }

</script>
<style scoped>
  .category-names {
    padding: 0px 0 12px 12px;
    border-radius: 4px;
    border: 1px solid var(--border-color-global, #E9E9E9);
    background: var(--bg-color-secondary-container, #FBFCFD);
  }
</style>